import React, { useEffect, useState } from "react";
import { FaSearch, FaRegBuilding, FaHouseUser } from "react-icons/fa";
import { GrLocationPin } from "react-icons/gr";
import apiClient from "../api.js";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaLocationDot, FaIndianRupeeSign } from "react-icons/fa6";
import { FaBuilding } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Autoplay } from "swiper/modules";
import "swiper/css/bundle";
import Popup from "../components/Popup.jsx";
import Canonical from "../components/Canonical.js";
import Testimonial from "../components/Testimonial.jsx";
import BuilderSlider from "../components/BuilderSlider.jsx";

const PuneHome = () => {
  const [name, setname] = useState("");
  const [areaDefault, setAreaDefault] = useState(false);
  const [results, setResults] = useState([]);
  const [regionProperty, setregionProperty] = useState([]);
  const [regionCommercial, setregionCommercial] = useState([]);
  const [discountedProperty, setdiscountedProperty] = useState([]);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const isPlotPage = location.pathname === "/pune";

  useEffect(
    (area) => {
      getArea(area);
      getPropertyDiscountedDeal();
      const delayDebounceFn = setTimeout(() => {
        if (name) {
          fetchSearchResults(name);
        } else {
          setResults([]); // Clear results if name is empty
        }
      }, 300); // 300ms debounce

      return () => clearTimeout(delayDebounceFn);
    },
    [name],
  );

  const fetchSearchResults = async (term) => {
    setLoading(true);
    try {
      const response = await apiClient.post("listing/punesearch", {
        name: term,
      });

      const properties = response.data;
      // console.log(properties);
      setResults(properties);
    } catch (error) {
      console.error("Error fetching search results:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setname(e.target.value);
  };

  const getPropertyByRegion = async (area) => {
    try {
      // console.log(area);

      if (areaDefault === false) {
        const area = "Pimpri Chinchwad";
        const response = await apiClient.get(
          `listing/regionpropertyfordisplay/${encodeURIComponent(area)}`,
        );
        setregionProperty(response.data);
        // console.log(response.data);
      } else {
        const response = await apiClient.get(
          `listing/regionpropertyfordisplay/${encodeURIComponent(area)}`,
        );
        setregionProperty(response.data);
        // console.log(response.data);
      }
    } catch (error) {
      console.error("Error fetching search results:", error);
    } finally {
      setLoading(false);
    }
  };

  const getCommercialByRegion = async (area) => {
    try {
      if (areaDefault === false) {
        const area = "Pimpri Chinchwad";
        const response = await apiClient.get(
          `listing/regioncommercialfordisplay/${encodeURIComponent(area)}`,
        );
        setregionCommercial(response.data);
      } else {
        const response = await apiClient.get(
          `listing/regioncommercialfordisplay/${encodeURIComponent(area)}`,
        );
        setregionCommercial(response.data);
      }
    } catch (error) {
      console.error("Error fetching search results:", error);
    } finally {
      setLoading(false);
    }
  };

  const areas = [
    "Pimpri Chinchwad",
    "Pune West",
    "Pune South",
    "Pune East",
    "Pune Center",
  ];

  const [activeArea, setActiveArea] = useState(areas[0]);

  useEffect(() => {
    getArea(areas[0]);
    getCommercialByRegion(areas[0]);
  }, []);

  const getArea = async (area) => {
    // console.log("Selected Area:", area);
    setActiveArea(area);
    setLoading(true);
    setAreaDefault(true);
    getPropertyByRegion(area);
    getCommercialByRegion(area);
  };

  const getPropertyDiscountedDeal = async (area) => {
    try {
      const responseDiscounted = await apiClient.get(
        `listing/punediscountedproperty`,
      );
      if (responseDiscounted) {
        setdiscountedProperty(responseDiscounted.data);
        // console.log(responseDiscounted.data);
        // console.log(discountedProperty);
      }
    } catch (error) {
      console.error("Error fetching search results:", error);
    } finally {
      setLoading(false);
    }
  };

  // handle popup button
  const [popupData, setPopupData] = useState("");

  const handleButtonClick = (dataName) => {
    // console.log(dataName);
    setPopupData(dataName);
  };

  const navigate = useNavigate();
  const handleCityChange = (e) => {
    if (e.target.value === "mumbai") {
      navigate("/");
    }
  };

  const getDisplaySubregion = (subregion) => {
    if (subregion === "Dombivali") return "Dombivli";
    else if (subregion === "Vikroli") return "Vikhroli";
    else if (subregion === "Vadala") return "Wadala";
    else return subregion;
  };

  const canonicalUrl = "https://homesdekho.com/pune";
  const hrfLangTag = "https://homesdekho.com/pune";
  const title = "Buy Property in Pune | Flats & Homes for Sale - Homes Dekho";
  const description =
    "Discover the best flats and properties in Pune with Homes Dekho. Browse verified listings, compare prices, and find your dream home in prime Pune locations. Enquire today!";

  return (
    <>
      <Canonical
        canonicalUrl={canonicalUrl}
        title={title}
        description={description}
        hrfLang={hrfLangTag}
      />

      <section className="banner-img">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="input-wrapper-top margin-search-bar">
                <div
                  className={`active-input-type-residentials-home ${
                    isPlotPage ? "" : "active-input-type-residential-home"
                  }`}
                >
                  <Link to="/">Residential / Commercial</Link>
                </div>
                <div
                  className={`active-input-type-plotss-home ${
                    isPlotPage ? "active-input-type-plots-home" : ""
                  }`}
                >
                  <Link to="/">Plots</Link>
                </div>
              </div>
              <div className="input-wrapper text-center">
                <select
                  className="select-city"
                  aria-label="Default select example"
                  onChange={handleCityChange}
                  defaultValue="pune"
                >
                  <option value="pune">Pune</option>
                  <option value="mumbai">Mumbai</option>
                </select>

                <FaSearch className="search-icon" />
                <input
                  value={name}
                  onChange={handleChange}
                  id="searchPropertyInput"
                  className="search-input"
                  placeholder="Location, Property, Developer"
                />
                <button onClick={fetchSearchResults} className="search-btn">
                  Search
                </button>
              </div>
              <div
                className="col-md-"
                style={
                  loading === false ? { display: "block" } : { display: "none" }
                }
              >
                {loading && <p className="text-center">Loading...</p>}

                <div className="search-result-div">
                  {results.map((result) => {
                    if (result.matchedField === "name") {
                      return (
                        <Link
                          className="search-link"
                          to={`property-detail/${result.slug}`}
                        >
                          <div
                            key={result._id}
                            className="inner-search-result-div"
                          >
                            <div className="building-icon-div">
                              <FaRegBuilding className="building-icon" />
                            </div>
                            <div className="project-name-div">
                              <p className="project-name-real">{result.name}</p>{" "}
                              <p className="project-name-txt">Project Name</p>
                            </div>
                          </div>
                        </Link>
                      );
                    } else if (result.matchedField === "address") {
                      return (
                        <Link
                          className="search-link"
                          to={`propertiesbyregion/${result.subregion.replace(
                            /\s+/g,
                            "-",
                          )}`}
                        >
                          <div
                            key={result._id}
                            className="inner-search-result-div"
                          >
                            <div className="building-icon-div">
                              <GrLocationPin className="building-icon" />
                            </div>
                            <div className="project-name-div">
                              <p className="project-name-real">
                                {result.subregion}
                              </p>{" "}
                              <p className="project-name-txt">
                                Project Address
                              </p>
                            </div>
                          </div>
                        </Link>
                      );
                    } else if (result.matchedField === "devlopername") {
                      return (
                        <Link
                          className="search-link"
                          to={`projects/${result.devlopername.replace(
                            /\s+/g,
                            "-",
                          )}`}
                        >
                          <div
                            key={result._id}
                            className="inner-search-result-div"
                          >
                            <div className="building-icon-div">
                              <FaHouseUser className="building-icon" />
                            </div>
                            <div className="project-name-div">
                              <p className="project-name-real">
                                {result.devlopername}
                              </p>{" "}
                              <p className="project-name-txt"></p>
                            </div>
                          </div>
                        </Link>
                      );
                    }
                    return null;
                  })}
                </div>
              </div>
            </div>
            <div className="col-md-6 d-none d-md-block">
              <div className="banner-txt-div">
                <div>
                  <h1 className="banner-heading">
                    Find Your <span>Dream</span> Home in <span>Pune</span>
                  </h1>
                  <p className="banner-subheading">
                    Take the next step to buy a home in Pune - Modern,
                    affordable, and hassle-free. Discover residential properties
                    with top amenities and seamless connectivity. Get the best
                    flats in pune on the trusted HomesDekho real estate portal.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="main-region-section mt-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <Swiper
                className="region-button"
                spaceBetween={10} // Space between slides
                slidesPerView={"auto"} // Force 8 slides to fit within the first view
                modules={[FreeMode, Navigation]}
                navigation={true}
                style={{
                  padding: "10px 0px", // Padding around text
                }}
              >
                {areas.map((area, index) => (
                  <SwiperSlide
                    key={area}
                    className="area-name-slider"
                    onClick={() => getArea(area)}
                    style={{
                      display: "inline-flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "200px",
                      padding: "10px 20px", // Padding around text
                      background: area === activeArea ? "#032B5F" : "#ffffff", // Highlight the first slide
                      color: area === activeArea ? "#FFFFFF" : "#000000",
                      border: "1px solid #032B5F",
                      borderRadius: "20px", // Rounded corners
                      whiteSpace: "nowrap", // Prevent text wrapping
                      flexShrink: 0, // Prevent slides from shrinking
                    }}
                  >
                    <div>{area}</div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </section>
      {/* region vise porperty */}
      <section>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <Swiper
                className="region-button"
                spaceBetween={10} // Space between slides
                freeMode={true} // Enable free scrolling
                navigation={true}
                modules={[FreeMode, Navigation]}
                style={{ padding: "10px 0" }}
                breakpoints={{
                  425: {
                    slidesPerView: 1, // Show 2 slides on small screens
                    spaceBetween: 10,
                  },
                  768: {
                    slidesPerView: 2, // Show 4 slides on tablets
                    spaceBetween: 15,
                  },
                  1024: {
                    slidesPerView: 1.5, // Show based on content on larger screens
                    spaceBetween: 20,
                  },
                }}
              >
                {Object.entries(regionProperty, regionProperty._id).map(
                  ([subregion, properties]) => (
                    <SwiperSlide key={regionProperty._id}>
                      <div className="hoomepage-region-main-div">
                        <div className="region-name-div-for-homepage">
                          <p className="regiona-name-txt">
                            Homes In {subregion}
                          </p>
                        </div>
                        <div className="top-projects-div">
                          <p className="top-projects-txt">
                            Top Projects In {subregion}
                          </p>
                        </div>
                        <div className="row">
                          <Swiper
                            className="region-button"
                            spaceBetween={10} // Space between slides
                            modules={[FreeMode, Autoplay]}
                            autoplay={{
                              delay: 2000, // Delay between slides in milliseconds (e.g., 2 seconds)
                              disableOnInteraction: false, // Allow autoplay to continue even after user interaction
                            }}
                            style={{ padding: "10px 10px" }}
                            breakpoints={{
                              425: {
                                slidesPerView: 1, // Show 2 slides on small screens
                                spaceBetween: 10,
                              },
                              768: {
                                slidesPerView: 2, // Show 4 slides on tablets
                                spaceBetween: 15,
                              },
                              1024: {
                                slidesPerView: 3, // Show based on content on larger screens
                                spaceBetween: 20,
                              },
                            }}
                          >
                            {properties.slice(0, 3).map((property, index) => (
                              <div className="col-md-12">
                                <SwiperSlide key={index}>
                                  <Link
                                    to={`property-detail/${property.slug}`}
                                    className="property-region-link"
                                  >
                                    <div className="homepage-property-main-div">
                                      <div>
                                        <img
                                          className="img-fluid property-img-region"
                                          src={property.imageUrls}
                                          alt={property.name}
                                        />
                                        <p className="property-name-txt-inner-for-regions">
                                          {property.name}
                                        </p>

                                        <p className="property-name-txt-inner-for-region">
                                          {property.BHK &&
                                          Array.isArray(property.BHK) ? (
                                            property.BHK.map((bhk, idx) => (
                                              <span key={idx}>
                                                {bhk}
                                                {idx <
                                                  property.BHK.length - 1 &&
                                                  ", "}
                                              </span>
                                            ))
                                          ) : (
                                            <span>Loading data...</span>
                                          )}{" "}
                                          BHK
                                        </p>
                                        <p className="property-price-range-region-vise">
                                          {property.price}
                                        </p>
                                      </div>
                                    </div>
                                  </Link>
                                </SwiperSlide>
                              </div>
                            ))}
                          </Swiper>
                          <p className="view-more-link-by-subregion">
                            <Link to={`propertiesbyregion/${subregion}`}>
                              View more Properties in {subregion}
                            </Link>
                          </p>
                        </div>
                      </div>
                    </SwiperSlide>
                  ),
                )}
              </Swiper>
            </div>
          </div>
        </div>
      </section>
      {/* region vise porperty  */}
      {/* Commercial Property Section */}
      <section>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <Swiper
                className="region-button"
                spaceBetween={10} // Space between slides
                freeMode={true} // Enable free scrolling
                navigation={true}
                modules={[FreeMode, Navigation]}
                style={{ padding: "10px 0" }}
                breakpoints={{
                  425: {
                    slidesPerView: 1, // Show 2 slides on small screens
                    spaceBetween: 10,
                  },
                  768: {
                    slidesPerView: 2, // Show 4 slides on tablets
                    spaceBetween: 15,
                  },
                  1024: {
                    slidesPerView: 1.5, // Show based on content on larger screens
                    spaceBetween: 20,
                  },
                }}
              >
                {Object.entries(regionCommercial, regionCommercial._id).map(
                  ([subregion, commercials]) => (
                    <SwiperSlide key={regionCommercial._id}>
                      <div className="hoomepage-region-main-div">
                        <div className="region-name-div-for-homepage">
                          <p className="regiona-name-txt">
                            Commercial Spaces in{" "}
                            {getDisplaySubregion(subregion)}
                          </p>
                        </div>
                        <div className="top-projects-div">
                          <p className="top-projects-txt">
                            Top Projects In {getDisplaySubregion(subregion)}
                          </p>
                        </div>
                        <div className="row">
                          <Swiper
                            className="region-button"
                            spaceBetween={10} // Space between slides
                            modules={[FreeMode, Autoplay]}
                            autoplay={{
                              delay: 2000, // Delay between slides in milliseconds (e.g., 2 seconds)
                              disableOnInteraction: false, // Allow autoplay to continue even after user interaction
                            }}
                            style={{ padding: "10px 10px" }}
                            breakpoints={{
                              425: {
                                slidesPerView: 1, // Show 2 slides on small screens
                                spaceBetween: 10,
                              },
                              768: {
                                slidesPerView: 2, // Show 4 slides on tablets
                                spaceBetween: 15,
                              },
                              1024: {
                                slidesPerView: 3, // Show based on content on larger screens
                                spaceBetween: 20,
                              },
                            }}
                          >
                            {commercials
                              .slice(0, 3)
                              .map((commercial, index) => (
                                <div className="col-md-12">
                                  <SwiperSlide key={index}>
                                    <Link
                                      to={`/pune/property-detail/${commercial.slug}`}
                                      className="property-region-link"
                                    >
                                      <div className="homepage-property-main-div">
                                        <div>
                                          <img
                                            className="img-fluid property-img-region"
                                            src={commercial.imageUrls}
                                            alt={commercial.name}
                                          />
                                          <p className="property-name-txt-inner-for-regions">
                                            {commercial.name}
                                          </p>
                                          <p className="property-name-txt-inner-for-region">
                                            {commercial.BHK &&
                                            Array.isArray(commercial.BHK) ? (
                                              commercial.BHK.map((bhk, idx) => (
                                                <span key={idx}>
                                                  {bhk}

                                                  {idx <
                                                    commercial.BHK.length - 1 &&
                                                    ", "}
                                                </span>
                                              ))
                                            ) : (
                                              <span>Loading data...</span>
                                            )}
                                          </p>
                                          <p className="property-price-range-region-vise">
                                            {commercial.price}
                                          </p>
                                        </div>
                                      </div>
                                    </Link>
                                  </SwiperSlide>
                                </div>
                              ))}
                          </Swiper>
                          <p className="view-more-link-by-subregion">
                            <Link
                              to={`commercialproperties/${subregion.replace(
                                /\s+/g,
                                "-",
                              )}`}
                            >
                              View more Properties in{" "}
                              {getDisplaySubregion(subregion)}
                            </Link>
                          </p>
                        </div>
                      </div>
                    </SwiperSlide>
                  ),
                )}
              </Swiper>
            </div>
          </div>
        </div>
      </section>
      {/* Commercial Property Section */}

      {/* discounted deals  */}
      <section>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <p className="subheading-txt">Discounted Deals</p>
            </div>
            <Swiper
              className="region-button"
              spaceBetween={10} // Space between slides
              modules={[FreeMode, Autoplay, Navigation]}
              navigation={true}
              autoplay={{
                delay: 2000, // Delay between slides in milliseconds (e.g., 3 seconds)
                disableOnInteraction: false, // Allow autoplay to continue even after user interaction
              }}
              style={{ padding: "10px 10px" }}
              breakpoints={{
                425: {
                  slidesPerView: 1, // Show 2 slides on small screens
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 2, // Show 4 slides on tablets
                  spaceBetween: 15,
                },
                1024: {
                  slidesPerView: 3, // Show based on content on larger screens
                  spaceBetween: 20,
                },
              }}
            >
              {Array.isArray(discountedProperty) &&
                discountedProperty.map((discountedProperty, index) => (
                  <div className="col-md-12">
                    <SwiperSlide key={index}>
                      <div className="discounted-deal-property-div">
                        <Link
                          to={`/property-detail/${discountedProperty.slug}`}
                          className="view-detail-btn-property-home-txt"
                        >
                          <img
                            src={discountedProperty.imageUrls}
                            className="discounted-property-img img-fluid "
                            alt={`Discounted property ${discountedProperty.name}`}
                          />
                        </Link>
                        <div className="disocunted-property-specs-div">
                          <p className="discounted-property-name">
                            <Link
                              to={`/property-detail/${discountedProperty.slug}`}
                              className="view-detail-btn-property-home-txt"
                            >
                              {discountedProperty.name}
                            </Link>
                          </p>
                          <p className="discounted-property-address-txt">
                            <FaLocationDot />
                            <span>{discountedProperty.address}</span>
                          </p>
                          <p className="discounted-property-BHK-txt">
                            <FaBuilding />
                            {discountedProperty.BHK &&
                            Array.isArray(discountedProperty.BHK) ? (
                              discountedProperty.BHK.map((bhk, idx) => (
                                <span key={idx}>
                                  {bhk}
                                  {idx < discountedProperty.BHK.length - 1 &&
                                    ", "}
                                </span>
                              ))
                            ) : (
                              <span>Loading data...</span>
                            )}{" "}
                            BHK
                          </p>
                          <p className="discounted-property-price">
                            <FaIndianRupeeSign />
                            <span>{discountedProperty.price}</span>
                          </p>
                          <div className="property-devloper-btn-home-div">
                            <Link
                              to={`/property-detail/${discountedProperty.slug}`}
                              className="view-detail-btn-property-home"
                            >
                              View Details
                            </Link>
                            <button
                              type="button"
                              data-bs-toggle="modal"
                              data-bs-target="#staticBackdrop"
                              className="get-call-btn-property-home-page"
                              onClick={() =>
                                handleButtonClick(discountedProperty.name)
                              }
                            >
                              Enquire Now
                            </button>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  </div>
                ))}
            </Swiper>
          </div>
        </div>
      </section>
      {/* discounted deals  */}

      {/* developer section auto scroll  */}
      <section>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <p className="subheading-txt">Top Builders in Pune</p>
            </div>
            <BuilderSlider />
          </div>
        </div>
      </section>
      {/* developer section auto scroll  */}

      {/* Pune Property Overview */}
      <section>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <p className="subheading-txt">
                Property in Pune | Premium Flats & Investment Homes Find the
                Best Property in Pune for Sale
              </p>
              <p className="home-page-developer-txt">
                For those looking to buy property in Pune, HomesDekho offers a
                trusted platform to explore verified residential options.
                Discover one of India’s fastest-growing real estate markets with
                verified residential and investment options across the city.
                Pune offers a wide range of homes to suit every buyer, from
                affordable 1BHK apartments to spacious family homes.
              </p>
              <p className="home-page-developer-txt">
                With infrastructure growing quickly, Pune is becoming a top
                choice for homebuyers and investors. The local IT ecosystem is
                expanding. At HomesDekho, we help you explore the best property
                in Pune with updated prices, verified listings, and expert
                support.
              </p>
              <p className="home-page-developer-txt">
                Explore premium flats, ready-to-move homes, under-construction
                projects, and investment properties in Pune-all in one place.
              </p>
              <p className="subheading-txt">Why Buy Property in Pune?</p>
              <p className="home-page-developer-txt">
                Pune is one of India’s most attractive real estate markets. It
                offers a balanced lifestyle, strong career options, and
                long-term value growth.
              </p>
              <p className="subheading-txt">
                Key Reasons to Invest in Pune Real Estate
              </p>
              <ul>
                <li>
                  Consistent Property Appreciation: Pune property prices have
                  shown stable growth over the years.
                </li>
                <li>
                  Strong IT & Employment Hubs: Hinjewadi, Kharadi, Magarpatta,
                  and Baner drive demand.
                </li>
                <li>
                  Excellent Rental Income Potential: High influx of
                  professionals and students.
                </li>
                <li>
                  Superior Lifestyle: Better climate, cleaner environment, and
                  modern social infrastructure.
                </li>
                <li>
                  Infrastructure Expansion: Metro access, ring roads, flyovers,
                  and improved road networks.
                </li>
                <li>
                  Trusted Developers: Projects by Godrej, Kolte Patil, VTP,
                  Panchshil, Lodha, and more.
                </li>
              </ul>
              <p className="home-page-developer-txt">
                Pune is ideal for first-time homebuyers and investors, with good
                prices and strong long-term growth.
              </p>
              <p className="subheading-txt">Pune Property Market Overview</p>
              <p className="home-page-developer-txt">
                Over the past decade, Pune has evolved into a major IT,
                education, and industrial hub. This transformation has fueled
                demand across both residential and commercial segments.
              </p>
              <p className="subheading-txt">Pune Real Estate Growth Drivers</p>
              <ul>
                <li>Expanding tech parks and business districts</li>
                <li>Increasing migration of professionals</li>
                <li>Upcoming metro and road projects</li>
                <li>Growing demand for gated communities</li>
                <li>Rising preference for lifestyle-centric homes</li>
              </ul>
              <p className="home-page-developer-txt">
                From compact apartments in new suburbs to premium homes in
                central Pune, the city fits every budget and lifestyle.
              </p>
              <p className="subheading-txt">
                Property Rates in Pune - Area-Wise Price Guide
              </p>
              <p className="home-page-developer-txt">
                Property rates in Pune depend on location, access, project
                quality, and amenities.
              </p>
              <p className="subheading-txt">Premium Localities</p>
              <ul>
                <li>
                  Properties in Koregaon Park typically cost between ₹15,000 and
                  ₹20,000 per sq. ft.
                </li>
                <li>
                  Properties in Kalyani Nagar generally cost between ₹13,000 and
                  ₹18,000 per sq. ft.
                </li>
                <li>
                  Properties in Viman Nagar generally cost between ₹12,000 to
                  ₹17,000 per sq. ft.
                </li>
              </ul>
              <p className="subheading-txt">Mid-Segment Hotspots</p>
              <ul>
                <li>
                  Properties in Baner typically cost between ₹9,000 and ₹13,000
                  per sq. ft.
                </li>
                <li>
                  Properties in Balewadi typically cost between ₹8,500 and
                  ₹12,000 per sq. ft.
                </li>
                <li>
                  Properties in Wakad typically cost between ₹8,000 and ₹11,500
                  per sq. ft.
                </li>
              </ul>
              <p className="subheading-txt">Affordable & High-Growth Areas</p>
              <ul>
                <li>
                  Properties in Tathawade typically cost between ₹6,000 and
                  ₹8,500 per sq. ft.
                </li>
                <li>
                  Properties in Punawale typically cost between ₹5,500 and
                  ₹8,000 per sq. ft.
                </li>
                <li>
                  Properties in Wagholi typically cost between ₹5,000 and ₹7,500
                  per sq. ft.
                </li>
                <li>
                  Properties in Moshi typically cost between ₹5,000 and ₹7,000
                  per sq. ft.
                </li>
              </ul>
              <p className="home-page-developer-txt">
                Note: Prices are indicative and may vary based on project stage,
                builder reputation, and market trends.
              </p>
              <p className="subheading-txt">
                Best Areas to Buy Property in Pune
              </p>
              <p className="home-page-developer-txt">
                Hinjewadi – Pune’s IT Investment Hub
              </p>
              <p className="home-page-developer-txt">
                Ideal for professionals and investors seeking strong rental
                returns and long-term appreciation.
              </p>
              <p className="home-page-developer-txt">
                Baner & Balewadi – Premium Lifestyle Locations
              </p>
              <p className="home-page-developer-txt">
                Perfect for families and working professionals looking for easy
                access, a vibrant social life, and premium projects.
              </p>
              <p className="home-page-developer-txt">
                Kharadi – Fastest Growing Residential Market
              </p>
              <p className="home-page-developer-txt">
                A hotspot for luxury apartments, gated communities, and high
                appreciation.
              </p>
              <p className="home-page-developer-txt">
                Wagholi – Affordable Homes with Future Potential
              </p>
              <p className="home-page-developer-txt">
                A suitable choice for first-time buyers seeking budget-friendly
                flats.
              </p>
              <p className="home-page-developer-txt">
                Undri & NIBM – Peaceful Premium Living
              </p>
              <p className="home-page-developer-txt">
                Popular for spacious homes, green surroundings, and quality
                lifestyles.
              </p>
              <p className="home-page-developer-txt">
                Wakad & Tathawade – Smart Investment Corridors
              </p>
              <p className="home-page-developer-txt">
                Well-connected micro-markets with modern projects and growing
                demand.
              </p>
              <p className="subheading-txt">
                How to Choose the Right Property in Pune
              </p>
              <p className="home-page-developer-txt">
                Buying the right property is easier when you follow a smart
                approach:
              </p>
              <ol>
                <li>
                  Define Your Goal: Are you buying to live, rent, or invest?
                </li>
                <li>Set a Realistic Budget</li>
                <li>
                  Account for registration charges, stamp duty, maintenance
                  costs, and interior expenses.
                </li>
                <li>
                  Choose the Right Locality: Consider commute, schools,
                  hospitals, and future growth.
                </li>
                <li>
                  Check Builder Track Record: Choose reputed developers with
                  timely delivery.
                </li>
                <li>
                  Compare Verified Listings: Use trusted platforms like
                  HomesDekho for transparent pricing and genuine listings.
                </li>
              </ol>
              <p className="subheading-txt">
                Pune Real Estate Trends & Investment Insights
              </p>
              <p className="home-page-developer-txt">
                Pune is a strong real estate market with steady housing demand,
                better roads and services, and a stable job market.
              </p>
              <p className="subheading-txt">
                Why Pune is a Smart Investment Market
              </p>
              <ul>
                <li>
                  Strong Capital Appreciation Potential: Areas like Kharadi,
                  Baner, Hinjewadi, and Wakad have seen steady property price
                  growth over time.
                </li>
                <li>
                  High Rental Demand: Pune’s IT parks, educational institutions,
                  and industrial hubs create consistent rental demand throughout
                  the year.
                </li>
                <li>
                  Affordable Entry Compared to Other Metros: Pune offers better
                  value than Mumbai, Bengaluru, and Delhi NCR in many segments.
                </li>
                <li>
                  Affordable Entry Compared to Other Metros: Pune offers better
                  value than Mumbai, Bengaluru, and Delhi NCR in many segments.
                </li>
                <li>
                  Low Vacancy in Key Areas: Premium and well-connected locations
                  continue to attract quality tenants and buyers.
                </li>
              </ul>
              <p className="subheading-txt">
                Best Pune Locations for Real Estate Investment
              </p>
              <ul>
                <li>
                  Hinjewadi: Ideal for rental income and IT-driven appreciation
                </li>
                <li>Kharadi: Premium growth corridor with strong demand</li>
                <li>
                  Wakad & Tathawade: High potential with relatively affordable
                  entry prices
                </li>
                <li>
                  Baner & Balewadi: Strong end-user demand and premium
                  positioning
                </li>
                <li>Wagholi: Budget investment with future upside</li>
              </ul>
              <p className="home-page-developer-txt">
                Pune’s property market continues to see strong buyer interest in
                the following:
              </p>
              <ul>
                <li>2 BHK and 3 BHK apartments in Baner, Wakad, and Kharadi</li>
                <li>Under-construction projects with flexible payment plans</li>
                <li>Ready-to-move flats for immediate possession</li>
                <li>Commercial and mixed-use developments for higher ROI</li>
              </ul>
              <p className="home-page-developer-txt">
                New projects like Pune Metro Phase 2, the Ring Road, and
                flyovers are likely to increase property prices in key areas.
              </p>
              <p className="subheading-txt">Why Choose HomesDekho?</p>
              <p className="home-page-developer-txt">
                HomesDekho helps serious homebuyers with clear information,
                faster decisions, and trusted support.
              </p>
              <p className="subheading-txt">What Makes HomesDekho Different?</p>
              <ul>
                <li>Verified listings with transparent pricing</li>
                <li>Exclusive builder deals and launch offers</li>
                <li>Virtual tours, floor plans, and project insights</li>
                <li>Personalized property shortlisting based on your budget</li>
                <li>
                  Expert support for site visits, negotiations, and paperwork
                </li>
                <li>Home loan assistance and legal guidance</li>
              </ul>
              <p className="home-page-developer-txt">
                Whether you are a first-time buyer or an investor, HomesDekho
                helps you move from search to site visit to final booking with
                confidence.
              </p>
              <p className="subheading-txt">
                Book a Free Property Consultation Today
              </p>
              <p className="home-page-developer-txt">
                Speak with our Pune property experts to:
              </p>
              <ul>
                <li>Compare top projects in your budget</li>
                <li>Get access to exclusive pre-launch offers</li>
                <li>Understand locality-wise appreciation trends</li>
                <li>Schedule site visits at your convenience</li>
              </ul>
              <p className="home-page-developer-txt">
                Ready to shortlist your ideal home? Connect with HomesDekho
                today for expert guidance and verified Pune property options.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Pune Property Overview */}
      {/* Review Section  */}
      <Testimonial />
      <Popup data={popupData} />
    </>
  );
};

export default PuneHome;
